export default __webpack_public_path__ + "static/media/210.5b953087.png";